import { render, staticRenderFns } from "./TabContainerIcon.vue?vue&type=template&id=ec5937d4&"
import script from "./TabContainerIcon.vue?vue&type=script&lang=js&"
export * from "./TabContainerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports